<app-modal-form
  [isOpen]="true"
  [formId]="'addTeamForm'"
  (closeModal)="cancelar()"
  [mainLabel]="'Guardar'"
  [mainIcon]="'save'"
  [mainDisabled]="form.invalid || (!!initialData && !hasChanges)"
  [loading]="isLoading"
  [cancelLabel]="'Cancelar'"
  [cancelIcon]="'cancel'"
  (mainAction)="onSubmit()"
  (cancelAction)="cancelar()"
>
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    [class.form-ready]="isModalReady"
    id="addTeamForm"
    class="form-layout"
  >
    <div class="form-layout__header">
      <app-form-title
        [main]="initialData ? 'Editar' : 'Crear'"
        [sub]="initialData ? 'grupo' : 'nuevo grupo'"
      ></app-form-title>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-20 gap-y-[12px] sm:gap-y-6">
      <div class="w-full">
        <app-form-input
          label="Nombre del grupo"
          type="text"
          [placeholder]="initialData && !groupNameControl.value ? 'N/A' : 'placeholder'"
          [control]="groupNameControl"
          tooltipText="Nombre descriptivo del equipo."
          [showHelpIcon]="true"
        ></app-form-input>
      </div>

      <div class="w-full">
        <app-form-input
          label="Prioridad"
          type="number"
          [placeholder]="initialData && !priorityControl.value ? 'N/A' : 'placeholder'"
          [control]="priorityControl"
          tooltipText="1 = Alta, 2 = Media, 3 = Baja"
          [showHelpIcon]="true"
        ></app-form-input>
      </div>

      <div class="w-full">
        <app-form-input
          label="Aplicación"
          type="select"
          [placeholder]="initialData && !appIdControl.value ? 'N/A' : 'Placeholder'"
          [control]="appIdControl"
          [options]="appOptions"
          tooltipText="Selecciona la aplicación asociada"
          [showHelpIcon]="true"
        ></app-form-input>
      </div>
    </div>
  </form>
</app-modal-form>
